import React from 'react';
import BottomNavbar from '../userNavbar/BottomNavbar';
import TopInfoBar from '../userNavbar/TopNavbar';

const UserNavbar = () => {
    return (
        <div className="sticky top-0 w-full z-50 ">
            <TopInfoBar/>
            <BottomNavbar />
        </div>
    );
};

export default UserNavbar;